import { c as _c } from "react/compiler-runtime";
import type { IconProps } from '../types';
import { getIconColor } from '../utils/get-icon-color';
const IcoUser24 = t0 => {
  const $ = _c(10);
  const {
    "aria-label": ariaLabel,
    className,
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = getIconColor(color);
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const iconColor = t1;
  let t2;
  let t3;
  if ($[2] !== iconColor) {
    t2 = <path d="M15.124 7.41669C15.124 9.14258 13.7249 10.5417 11.999 10.5417C10.2731 10.5417 8.87402 9.14258 8.87402 7.41669C8.87402 5.6908 10.2731 4.29169 11.999 4.29169C13.7249 4.29169 15.124 5.6908 15.124 7.41669Z" stroke={iconColor} strokeWidth={2} strokeLinejoin="round" />;
    t3 = <path d="M11.9986 13.0417C8.83561 13.0417 6.52688 15.1446 5.89158 17.9714C5.78391 18.4505 6.17292 18.875 6.66397 18.875H17.3333C17.8243 18.875 18.2133 18.4505 18.1057 17.9714C17.4703 15.1446 15.1616 13.0417 11.9986 13.0417Z" stroke={iconColor} strokeWidth={2} strokeLinejoin="round" />;
    $[2] = iconColor;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== ariaLabel || $[6] !== className || $[7] !== t2 || $[8] !== t3) {
    t4 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label={ariaLabel} className={className} role="img" data-colored={false}>{t2}{t3}</svg>;
    $[5] = ariaLabel;
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default IcoUser24;